import { useTranslation } from 'react-i18next';
import { Loader } from '../Loader';
import style from './style.module.css';

interface UserLoadingScreenProps {
    /** Utilisateur non chargé faute de réseau : la session est gardée, on le dit. */
    offline: boolean;
}

/** Attente du chargement de l'utilisateur au démarrage (UserProvider). */
const UserLoadingScreen = ({ offline }: UserLoadingScreenProps): JSX.Element => {
    const { t } = useTranslation();
    return (
        <div className={style.screen}>
            <Loader disableBg>
                {offline && (
                    <div className={style.offline} role="status">
                        <p className={style.title}>{t('Pas de connexion internet')}</p>
                        <p className={style.text}>
                            {t(
                                "Vous restez connecté(e). Stimul'In reprendra dès le retour du réseau."
                            )}
                        </p>
                    </div>
                )}
            </Loader>
        </div>
    );
};

export default UserLoadingScreen;
